import { scroll } from "./scroll";

export const simpleModal = () => {
	if (!checkModalExists()) return;

	// Get all modal triggers
	const modalTriggers = document.querySelectorAll("[data-simple-modal-target-id]");
	// add event to each of these to open the modal
	modalTriggers.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();

			const modalID = trigger.getAttribute("data-simple-modal-target-id");
			const modal = document.getElementById(modalID);
			openModal(modal);
		});
	});

	// Get all close modal buttons
	const closeButtons = document.querySelectorAll(".close-modal");
	// add event to each of these to close the modal
	closeButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();
			const modal = button.closest(".modal");
			if (!modal) return;
			closeModal(modal);
		});
	});
};

const checkModalExists = () => {
	let modalExists = false;
	const elementsToCheck = [
		".modal",
		"[data-simple-modal]",
		"[data-simple-modal-target-id]",
		"[data-simple-modal-id]",
	];
	elementsToCheck.forEach((el) => {
		if (document.querySelector(el)) {
			modalExists = true;
		}
	});
	return modalExists;
};

const openModal = (modal) => {
	// get height of modalBox

	// add a fade in class to the modal for 0.5s and then add the open class and remove the fade in class
	modal.classList.add("fade-in");
	setTimeout(() => {
		modal.classList.remove("fade-in");
		modal.classList.add("open");
		document.body.classList.add("modal-open");
	}, 500);

	scroll.stop();

	// add event listener to close the modal
	modal.addEventListener("click", (e) => {
		if (e.target.classList.contains("modal") || e.target.classList.contains("close-modal")) {
			closeModal(modal);
		}
	});
};

const closeModal = (modal) => {
	modal.classList.remove("open");
	document.body.classList.remove("modal-open");

	// Revert any dynamic styling if necessary
	modal.style.transform = ""; // Reset to whatever your default styling is
	scroll.start();
};
